import { Box, Grid, InputAdornment, TextField } from '@material-ui/core';
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import MemoryIcon from '@material-ui/icons/Memory';
import SimCardOutlinedIcon from '@material-ui/icons/SimCardOutlined';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useFormikContext } from 'formik';
import React from 'react';
import { vehicleType } from 'src/app/constant/vehicleType';
import {
  CustomSwitchWithText,
  FieldIcon,
  FieldLabel,
  SectionTitle
} from '../components/common';
import useStyles from '../styles';

// Tab "Cấu hình thiết bị": thông tin thiết bị + thông tin phương tiện
export default function DeviceInfoSection({
  allowEditLicensePlate,
  onToggleEditLicensePlate,
  useSuggestedName,
  onToggleSuggestedName
}) {
  const classes = useStyles();
  const { values, touched, errors, handleBlur, handleChange, setFieldValue } =
    useFormikContext();

  const handleSelectVehicle = value => {
    const target = vehicleType.find(type => type.id === Number(value.id));
    if (target) setFieldValue('vehicle_type', target.name);
  };

  return (
    <>
      <Box className={classes.sectionCard}>
        <SectionTitle title="Thông tin thiết bị" />
        <Grid container spacing={2}>
          <Grid item md={4} xs={12}>
            <Box className={classes.switchFieldHeader}>
              <FieldLabel>Serial thiết bị</FieldLabel>
            </Box>
            <TextField
              fullWidth
              disabled
              className={`input-no-fieldset ${classes.textField} ${classes.monoInput}`}
              name="serial"
              size="small"
              value={values.serial || ''}
              variant="outlined"
              InputProps={{
                endAdornment: <FieldIcon icon={LockOutlinedIcon} />
              }}
            />
          </Grid>

          <Grid item md={4} xs={12}>
            <Box className={classes.switchFieldHeader}>
              <FieldLabel>Phiên bản Hardware</FieldLabel>
            </Box>
            <TextField
              className={`input-no-fieldset ${classes.textField}`}
              fullWidth
              disabled
              name="version"
              size="small"
              value={values.version || ''}
              variant="outlined"
              InputProps={{
                endAdornment: <FieldIcon icon={MemoryIcon} />
              }}
            />
          </Grid>

          <Grid item md={4} xs={12}>
            <Box className={classes.switchFieldHeader}>
              <FieldLabel>Số SIM thiết bị</FieldLabel>
            </Box>
            <TextField
              error={Boolean(touched.sim_phone && errors.sim_phone)}
              className={`input-no-fieldset ${classes.textField}`}
              fullWidth
              helperText={touched.sim_phone && errors.sim_phone}
              name="sim_phone"
              size="small"
              placeholder="Nhập số SIM thiết bị..."
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.sim_phone || ''}
              variant="outlined"
              InputProps={{
                endAdornment: <FieldIcon icon={SimCardOutlinedIcon} />
              }}
            />
          </Grid>
        </Grid>
      </Box>

      <Box className={classes.sectionCard}>
        <SectionTitle title="Thông tin phương tiện" />
        <Grid container spacing={2}>
          <Grid item xl={3} md={4} sm={6} xs={12}>
            <Box className={classes.switchFieldHeader}>
              <FieldLabel>Loại phương tiện</FieldLabel>
            </Box>
            <Autocomplete
              id="edit-device-vehicle-type"
              size="small"
              options={vehicleType || []}
              getOptionLabel={option => option.name}
              value={(vehicleType || []).find(
                option => option.name === values.vehicle_type
              )}
              onChange={(e, value) =>
                handleSelectVehicle(value)
              }
              disableClearable
              renderInput={params => (
                <TextField
                  {...params}
                  className={`input-no-fieldset ${classes.textField}`}
                  variant="outlined"
                  placeholder="Chọn loại phương tiện"
                  name="vehicle_type"
                  onBlur={handleBlur}
                />
              )}
            />
          </Grid>

          <Grid item xl={3} md={4} sm={6} xs={12}>
            <Box className={classes.switchFieldHeader}>
              <FieldLabel>Biển số</FieldLabel>
              <CustomSwitchWithText
                size="small"
                checked={allowEditLicensePlate}
                onChange={e => onToggleEditLicensePlate(e.target.checked)}
                name="allowEditLicensePlate"
                inputProps={{ 'aria-label': 'edit license plate' }}
              />
            </Box>
            <TextField
              error={Boolean(
                touched.license_plate && errors.license_plate
              )}
              className={`input-no-fieldset ${classes.textField} ${classes.plateInput}`}
              fullWidth
              helperText={
                touched.license_plate && errors.license_plate
              }
              name="license_plate"
              size="small"
              disabled={!allowEditLicensePlate}
              placeholder="Nhập biển số"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.license_plate || ''}
              variant="outlined"
              InputProps={{
                endAdornment: <FieldIcon icon={DirectionsCarIcon} />
              }}
            />
          </Grid>

          <Grid item xl={3} md={4} sm={6} xs={12}>
            <Box className={classes.switchFieldHeader}>
              <FieldLabel>Tên gợi nhớ</FieldLabel>
              <CustomSwitchWithText
                size="small"
                checked={useSuggestedName}
                onChange={onToggleSuggestedName}
                name="useSuggestedName"
                inputProps={{ 'aria-label': 'use suggested name' }}
              />
            </Box>
            <TextField
              className={`input-no-fieldset ${classes.textField}`}
              fullWidth
              disabled={!useSuggestedName}
              name="name"
              size="small"
              placeholder="Nhập tên gợi nhớ..."
              value={values.name || ''}
              onBlur={handleBlur}
              onChange={handleChange}
              variant="outlined"
            />
          </Grid>

          <Grid item xl={3} md={4} sm={6} xs={12}>
            <Box className={classes.switchFieldHeader}>
              <FieldLabel>Vận tốc tối đa</FieldLabel>
            </Box>
            <TextField
              className={`input-no-fieldset ${classes.textField} ${classes.strongInput}`}
              fullWidth
              name="maximum_speed"
              size="small"
              type="number"
              placeholder="Nhập vận tốc..."
              value={values.maximum_speed ?? ''}
              onBlur={handleBlur}
              onChange={handleChange}
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <span className={classes.unitText}>km/h</span>
                  </InputAdornment>
                )
              }}
            />
          </Grid>


        </Grid>
      </Box>
    </>
  );
}
